'use client';

import { pick as _pick } from 'lodash-es';
import { useSearchParams } from 'next/navigation';
import Main from '@/components/main';
import CalendarLayout from '@/components/calendar/calendar-layout';
import CalendarSidebar from '@/components/calendar/sidebar';
import type { CalendarFilters } from '@/components/calendar/filter-bar';
import type { Category } from '@/types/Event/Category';
import CalendarFooter from '@/components/calendar/footer';
import CalendarEventList from './CalendarEventList';

export default function CalendarPageClient({ cityId, bannerDismissed }: { cityId: string; bannerDismissed: boolean }) {
  const searchParams = useSearchParams();

  // Parse filters from URL searchParams (mirrors server-side parsing)
  const params: Record<string, string> = {};
  searchParams.forEach((value, key) => { params[key] = value; });

  const urlStart = params.start || null;

  const filters: CalendarFilters = {
    ..._pick(params, ['filter', 'type', 'categoryIds']) as Pick<CalendarFilters, 'filter' | 'type'>,
    categoryIds: params.categoryIds ? params.categoryIds.split(',') as Category[] : null,
    startDate: urlStart ? new Date(urlStart + 'T00:00:00').toISOString() : null,
  };

  // Key resets pagination state (additionalEvents, cursor) whenever filters change
  const filterKey = JSON.stringify(filters);

  return (
    <Main signupBanner bannerDismissed={bannerDismissed}>
      <CalendarLayout sidebar={<CalendarSidebar cityId={cityId} view="list" />}>
        <CalendarEventList
          key={filterKey}
          cityId={cityId}
          filters={filters}
          urlStart={urlStart}
        />
        <CalendarFooter />
      </CalendarLayout>
    </Main>
  );
}
